import './attachment.less';
import PropTypes from 'prop-types';
import React from 'react';

const PromoUpload = props => (
	<div className="form-element-upload__attachment">
		<div className="form-element-upload__control">
			<p className="title">{props.placeholder}</p>
		</div>
		<input
			key={getKey(props)}
			type="file"
			className="control"
			onChange={e => props.preparationFile(e.target.files[0], props.input.onChange)}/>
	</div>
);

PromoUpload.propTypes = {
	placeholder: PropTypes.string,
	accent: PropTypes.string,
	input: PropTypes.object,
	preparationFile: PropTypes.func
};

// This is necessary to clear the file metadata
// The redux-form works only with state
const getKey = (props) => props.input.value ? props.input.value.name : +new Date();

export default PromoUpload;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/attachment.js